import CircleIcon from '@mui/icons-material/Circle';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import { Rating } from '@mui/material';
import { RatingProps } from '@mui/material/Rating';
import { useState, useMemo } from 'react';

type PriorityRatingProps = Omit<RatingProps, 'onChangeActive'>;

enum PriorityColorType {
  primary = 'primary',
  error = 'error',
  warning = 'warning',
}

const colorFromPriority = (priority?: number | null): PriorityColorType => {
  switch (priority) {
    case 3:
      return PriorityColorType.error;
    case 2:
      return PriorityColorType.warning;
    default:
      return PriorityColorType.primary;
  }
};

export const PriorityRating = (props: PriorityRatingProps) => {
  const [activePriority, setActivePriority] = useState<number>(-1);
  const color = useMemo(
    () => colorFromPriority(activePriority > 0 ? activePriority : props.value),
    [activePriority, props.value],
  );
  return (
    <Rating
      name="priority"
      precision={1}
      max={3}
      icon={<CircleIcon color={color} fontSize="small" />}
      emptyIcon={<CircleOutlinedIcon fontSize="small" />}
      onChangeActive={(_event, value) => {
        setActivePriority(value);
      }}
      {...props}
    />
  );
};
